<!-- 0待填报 1已填报 -->
<template>
  <div class="statusBox">
    <div
      :class="[
        value == 0 ? 'red' : value == 1 ? 'green' : 'yellow',
        'status_icon',
      ]"
    ></div>
    <span :class="[value == 0 ? 'redColor' : value == 1 ? 'greenColor' : 'yellowColor']">
      {{ value == 0 ? "待激活" : value == 1 ? "已激活" : "——" }}</span
    >
  </div>
</template>

<script>
export default {
  name: "VipCardStatus",
  components: {},
  props: {
    value: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="less">
.statusBox {
  height: 100%;
  display: flex;
  align-items: center;
}
.status_icon {
  width: 6px;
  height: 6px;
  border-radius: 6px;
  margin-right: 10px;
}
.green {
  background: #30a46c;
}
.red {
  background: #ef7a59;
}
.yellow {
  background: #fb9a0e;
}
.greenColor {
  color: #30a46c;
}
.redColor {
  color: #ef7a59;
}
.yellowColor {
  color: #fb9a0e;
}
</style>
